import ModalContainer from "./ModalContainer";
import React from "react";
import Loader from "../../../../../../../NewComponents/Loader/Loader.component";

interface IConfirmModal {
  open: boolean;
  handleOk: () => void;
  handleCancel: () => void;
  title: string;
  confirmBtnText: any;
  cancelBtnTxt: string;
  isLoading: boolean;
}

const ConfirmModal = ({
  open,
  handleCancel,
  handleOk,
  title,
  confirmBtnText,
  cancelBtnTxt,
  isLoading,
}: IConfirmModal) => {
  return (
    <ModalContainer
      open={open}
      handleOk={handleOk}
      handleCancel={handleCancel}
      title={title}
      cancelBtnTxt={cancelBtnTxt}
      confirmBtnText={isLoading ? <Loader /> : confirmBtnText}
    >
      <h2>Are you sure you want to enable this provider</h2>
    </ModalContainer>
  );
};

export default ConfirmModal;
